import React, { useState, useEffect,useRef } from 'react';
import { Icon } from "@iconify/react";
import DataTable from "./../common/DataTable";
import DropdownMenu from "./../common/DropdownMenu";
import Modal from './../common/Modal';
import TableWithPagination from './../common/TableWithPagination';
import { useApi } from '../../hooks/useApi';


const Usuarios = () => {

  const [usuarios, setUsuarios] = useState([]);
  const [form, setForm] = useState({ nombre: '', email: '', rol: '', numEmpleado: '',estatus:'', rolId: '', estatusId: '',numEmpleado: ''  });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { get, post, put, del } = useApi();
  const [perfiles, setPerfiles] = useState([]);


  // Simula carga inicial con datos falsos
  const obtenerUsuarios = async () => {

      const data = await get('ListaUsuarios');
      console.log(data);
      setUsuarios(data);
      setLoading(false);
    };

  useEffect(() => {
    setLoading(true);
    obtenerUsuarios();
    }, []);

  useEffect(() => {
    const fetchPerfiles = async () => {
      try {
        const data = await get('ListaRoles');
        setPerfiles(data);
      } catch (error) {
        console.error("Error cargando perfiles:", error);
      }
    };
    fetchPerfiles();
  }, []);



const handleSubmit = async e => {
  e.preventDefault();
  setError(null);
  console.log(form);
  if (!form.nombre || !form.email || !form.rolId) {
    setError('Todos los campos son obligatorios');
    return;
  }

  try {
    setLoading(true); // (opcional) para mostrar spinner o deshabilitar botón

    let response;
    const payload = {
      Id: editId || undefined, // si editId existe, lo enviamos
      Nombre: form.nombre,
      Email: form.email,
      Perfil: Number(form.rolId),
      NumEmpleado: form.numEmpleado,
      Estatus: form.estatusId
    };

    console.log(payload);
    var data =  await post('updateUsuario', payload);

    setForm({ nombre: '', email: '', rolId: '' });
    setEditId(null);
    setShowModal(false);
    
    await obtenerUsuarios();


  } catch (error) {
    setError(error.message || 'Error al guardar');
  } finally {
    setLoading(false);
  }
};


const handleEdit = usuario => {
  setForm({ nombre: usuario.nombre, 
          email: usuario.email, 
          rol: usuario.rol, 
          rolId: usuario.rolId,
          numEmpleado: usuario.numEmpleado,
          estatus: usuario.estatus,
          estatusId: usuario.estatusId
        });
  setEditId(usuario.id);
  setShowModal(true);
};


  const handleDelete = async (id) => {
  if (!window.confirm("¿Estás seguro de eliminar este usuario?")) return;

  try {
    await del('deleteUser', { urlParams: { id } }); 
    obtenerUsuarios(); // refresca la tabla
    
  } catch (err) {
    console.error(err);
    
  }
};


  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <div className="lg:col-span-8 col-span-12">
      <div className="flex justify-between items-center flex-wrap mb-6">
        {/* Título a la izquierda */}
        <h6 className="font-bold text-base mb-2 sm:mb-0">Usuarios</h6>

        {/* DatePicker a la derecha */}
        <div className="relative">
          <button
                onClick={() => {
                setForm({ nombre: '', email: '', rol: '' });
                setEditId(null);
                setShowModal(true);
                }}
                className="px-2 py-1 text-sm bg-green-900 text-white rounded hover:bg-green-700"
            >
                + Nuevo
            </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="relative overflow-y-visible overflow-x-auto lg:overflow-x-visible mx-4 pt-3">
              <div className="inline-block min-w-full align-middle">
                {loading && <div className="text-center py-4">Cargando...</div>}
                <TableWithPagination
                  columns={[
                    { header: "#Empleado", accessor: "numEmpleado" },
                    { header: "Nombre", accessor: "nombre" },
                    { header: "Email", accessor: "email" },
                    { header: "Perfil", accessor: "rol" },
                    { header: "Estatus", accessor: "estatus" },
                  ]}
                  data={usuarios.map((u) => ({
                    id: u.userId,
                    nombre: u.name,
                    email: u.email,
                    rol: u.rol,
                    rolId: u.roleId,
                    numEmpleado: u.employeeNumber,
                    estatus: (
                          <span className="flex items-center gap-2">
                            <span
                              className={`w-3 h-3 rounded-full inline-block ${
                                u.status === 1 ? "bg-green-500" : "bg-red-500"
                              }`}
                            />
                            {u.status === 1 ? "Activo" : "No activo"}
                          </span>
                        ),
                  estatusId: u.status,
                    
                  }))}
                  showView={false}
                  showDelete={false}
                  onEdit={(u) => handleEdit(u)}
                  onDelete={(u) => handleDelete(u.id)}
                  searchPlaceholder="Buscar usuario..."
                />

                <Modal
                    show={showModal}
                    onClose={() => {
                        setShowModal(false);
                        setForm({ nombre: '', email: '', rol: '' });
                        setEditId(null);
                    }}
                    title={editId ? 'Editar Usuario' : 'Agregar Usuario'}
                    >
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label className="block mb-1"># Empleado</label>
                        <input
                            type="text"
                            name="numEmpleado"
                            value={form.numEmpleado}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                        </div>

                        <div className="mb-3">
                        <label className="block mb-1">Nombre</label>
                        <input
                            type="text"
                            name="nombre"
                            value={form.nombre}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                        </div>
                        <div className="mb-3">
                        <label className="block mb-1">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                        </div>
                        <div className="mb-3">
                        <label className="block mb-1">Perfil</label>
                        <select
                            value={form.rolId || ""}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                rolId: e.target.value,
                              })
                            }
                            className="border rounded px-3 py-2 w-full"
                          >
                            <option value="">Seleccione un perfil</option>
                            {perfiles.map((p) => (
                              <option key={p.id} value={p.id}>
                                {p.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-3">
                        <label className="block mb-1">Estatus</label>
                        <select 
                            value={form.estatusId !== undefined ? String(form.estatusId) : ""}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                estatusId: Number(e.target.value),

                              })
                            }
                            className="border rounded px-3 py-2 w-full"
                          >
                            <option value="">Seleccione un estatus</option>
                            <option value="1">Activo</option>
                            <option value="0">Inactivo</option>
                        </select>
                        </div>
                        <div className="flex justify-end gap-2">
                        <button
                            type="button"
                            onClick={() => {
                            setShowModal(false);
                            setForm({ nombre: '', email: '', rol: '' });
                            setEditId(null);
                            }}
                            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                        >
                            {editId ? 'Actualizar' : 'Guardar'}
                        </button>
                        </div>
                    </form>
                </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Usuarios;
